<template>
  <div class="about">
    <img src="../assets/images/E/h-bg2.png" width="100%" height="100%" alt>
    <!-- <ivheader></ivheader> -->
    <router-link to="/cityA1">城市概览</router-link>
    <router-link style="color: red;" to="/cityE1">城市号聚合页</router-link>
  </div>
</template>
<script>
export default {
  data () {
    return {
      lang_hide: 'zh'
    }
  }
}
</script>

<style>
</style>
